import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getExchangeRates, convert, format } from '../services/ratesService.js';

const RatesContext = createContext(null);

export function RatesProvider({ children }) {
  const [ratesPayload, setRatesPayload] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (force = false) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getExchangeRates({ forceRefresh: force });
      setRatesPayload(data);
    } catch (e) {
      setError(e.message || 'Failed to load rates');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh(false);
  }, [refresh]);

  const fetchedAt = ratesPayload?.fetchedAt ? Date.parse(ratesPayload.fetchedAt) : null;
  const isStale = fetchedAt ? (Date.now() - fetchedAt) > (1000 * 60 * 60 * 6) : false; // stale after 6h client side
  const value = {
    ratesPayload,
    rates: ratesPayload?.rates || null,
    asOfDate: ratesPayload?.asOfDate || null,
    fetchedAt,
    isStale,
    loading,
    error,
    refresh,
    convert: (amount, from, to) => convert(amount, from, to, ratesPayload),
    format: (amount, code, opts) => format(amount, code, opts)
  };

  return <RatesContext.Provider value={value}>{children}</RatesContext.Provider>;
}

export function useRates() {
  const ctx = useContext(RatesContext);
  if (!ctx) throw new Error('useRates must be used within <RatesProvider>');
  return ctx;
}
